import { Component, OnInit, Inject } from '@angular/core';
import { PushNotificationService } from '@notification/push-notification.service';
import { SelectionModel } from '@angular/cdk/collections';
import { NotificationTag } from '@root/common/select-notification-dialog/notifcation-tag.model';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@root/common/confirmation-dialog/confirmation-dialog.component';
import { IFAListService } from '@ifa/ifa-list.service';
import { ToastrService } from 'ngx-toastr';
import { IFA } from '@ifa/ifa-list-container/ifa-list-container.model';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { Something_went_wrong } from "@root/app.constant";

@Component({
  selector: 'app-ifa-tag-dialog',
  templateUrl: './ifa-tag-dialog.component.html',
  styleUrls: ['./ifa-tag-dialog.component.scss'],
  providers: [PushNotificationService, IFAListService],
})
export class IfaTagDialogComponent implements OnInit {
  tagList: any;

  tagSelection = new SelectionModel<NotificationTag>(true, []);

  mode: string;

  ifa: IFA;

  selectedTagMap: { [key: number]: any } = {};

  constructor(
    private pushnotificationService: PushNotificationService,
    public dialog: MatDialog,
    private ifaListService: IFAListService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IfaTagDialogComponent>
  ) {
    this.mode = data.value;
    this.ifa = data.ifa;
  }

  ngOnInit() {
    this.setSelectedTagMap();
    this.readAllTag();
  }

  private setSelectedTagMap() {
    if (this.ifa && this.ifa.tags) {
      this.ifa.tags.forEach((tag) => {
        this.selectedTagMap[tag['tagId']] = tag;
      });
    }
  }

  public readAllTag() {
    this.pushnotificationService.readAllNotificationTags().subscribe(
      (response) => {
        const tagList = response.data.tag || [];

        this.tagList = tagList.filter((tag) => !this.selectedTagMap[tag.id]);
      },
      (error) => {}
    );
  }

  public onSelectTags() {
    this.tagList.forEach((tag) => this.tagSelection.select(tag));
  }

  public onClearTags() {
    this.tagSelection.clear();
  }

  public onDeleteTagDialog(tags, mode) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '500px',
      data: { value: tags, mode },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        const selectedTags = tags.map((t) => {
          return t.id;
        });
        const obj = {
          tags: selectedTags.toString(),
        };
        this.ifaListService.deleteTag(obj).subscribe(
          (response) => {
            switch (response.status) {
              case 0:
                this.toastr.success(response.message);
                this.readAllTag();
                this.dialogRef.close();
                break;
              case -100:
                this.toastr.error(response.message);
                break;
              case -1:
                this.toastr.error(Something_went_wrong);
                break;
              default:
                this.toastr.error(response.error.errorMessage);
                break;
            }
          },
          (error) => {
            switch (error.status) {
              case -100:
                this.toastr.error(error.message);
                break;
              case -1:
                this.toastr.error(Something_went_wrong);
                break;
              default:
                this.toastr.error(error.error.errorMessage);
                break;
            }
          }
        );
      }
    });
  }

  public onAddUserTagDialog(tags, mode) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '250px',
      width: '500px',
      data: { value: tags, mode },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        const selectedTags = tags.map((t) => {
          return t.id;
        });
        const obj = {
          arnCode: this.ifa.arnCode,
          tags: selectedTags.toString(),
        };
        this.ifaListService.addUserInTag(obj).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.dialogRef.close(true);
            }
            this.errorHandler.handleError(response);
          },
          (error) => {
            this.errorHandler.handleError(error);
          }
         
        );
      }
    });
  }
}
